import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const AppContainer = styled.div`
  display: flex;
  background: ${ThemePrisma.colors.lightblue[7]};
`;

export const ContentContainer = styled.div`
  flex: 1;
`;

export const AppContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${ThemePrisma.spacing.small} ${ThemePrisma.spacing.large}
    ${ThemePrisma.spacing.large} ${ThemePrisma.spacing.large};
  min-height: calc(100vh - 113px);
  background: #e6edf2;
  border-top: 1px solid #004877;
  border-left: 1px solid #004877;

  @media (min-width: 1365px) {
    padding: ${ThemePrisma.spacing.small} ${ThemePrisma.spacing['xlarge']}
      ${ThemePrisma.spacing.large} ${ThemePrisma.spacing['xlarge']};
  }
`;

export const UnloggedAppContainer = styled.div`
  background-color: #e6ebf2;
  min-height: calc(100vh);

  div.header {
    width: 100%;
    height: 180px;
    display: flex;
    align-items: end;
    color: ${ThemePrisma.colors.gray[2]};
    background: ${ThemePrisma.colors.lightblue[7]};

    div.title-container {
      width: 100%;
      padding-bottom: 8px;
      display: flex;
      align-items: center;

      div.title {
        flex: 1;
      }

      div.icon {
        flex: 0;
      }
    }
  }

  div.content {
    padding-top: 20px;
    padding-bottom: 50px;
  }
`;
